import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {facilitatorUiTexts} from 'data/ui-texts';
import {adminUiTexts} from 'data/ui-texts';
import Logo from 'components/ui/logo/logo';
import Button from 'components/ui/button/button';
import Users from 'components/admin/users/users';
import Stats from 'components/admin/stats/stats';
import './admin.scss';

const Admin = ({userId, users, allowedUsers, handleGoToPage, deleteUser}) => {
	/* Page (users / stats) */
	const [page, setPage] = useState('users');


	return (
		<div className="Admin">
			{/* Logo */}
			<div className="Admin-logo"><Logo page="admin" /></div>

			{/* Navigation */}
			<div className="Admin-navigation">
				<div 
					className={'Admin-navigationItem' + (page === 'users' ? ' selected' : '')}
					onClick={() => {setPage('users');}}
				>
					<span>{adminUiTexts.users}</span>
				</div>
				<div 
					className={'Admin-navigationItem' + (page === 'stats' ? ' selected' : '')}
					onClick={() => {setPage('stats');}}
				>
					<span>{adminUiTexts.stats}</span>
				</div>
			</div>


			{/* Page component */}
			<div className="Admin-page">
				{page === 'users' && 
					<Users 
						userId={userId}
						users={users}
						allowedUsers={allowedUsers}
						handleGoToPage={handleGoToPage}
						deleteUser={deleteUser}
					/>
				}
				{page === 'stats' && 
					<Stats 
						userId={userId}
						users={users}
						allowedUsers={allowedUsers}
						handleGoToPage={handleGoToPage}
						deleteUser={deleteUser}
					/>
				}
			</div>


			{/* Settings btn */}
			<div className="Admin-settingsBtn">
				<Button 
					classes={['red', 'logout']} 
					text={facilitatorUiTexts.lobby} 
					onClick={() => {handleGoToPage('settings');}}
				/>
			</div>
		</div>
	);
};

Admin.propTypes = {
	userId: PropTypes.string.isRequired,
	users: PropTypes.array.isRequired,
	allowedUsers: PropTypes.array.isRequired,
	deleteUser: PropTypes.func.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
};

export default Admin;
